import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
// import GIF from './images/584655D4-B26B-4EFD-BD9F-A646350ACED3.gif'
// 样式化组件
const FloatingOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  animation: fadeIn 0.3s ease-out;
`;

const FloatingContent = styled.div`
  position: relative;
  max-width: 90vw;
  max-height: 80vh;
  animation: slideIn 0.3s ease-out;
`;

const FloatingImage = styled.img`
  max-width: 100%;
  max-height: 80vh;
  // border-radius: 8px;
  // box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  display: block;
`;

// 添加全局动画
const GlobalStyle = `
  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  @keyframes slideIn {
    from {
      transform: scale(0.7);
      opacity: 0;
    }
    to {
      transform: scale(1);
      opacity: 1;
    }
  }
`;

const FloatingImageComponent = ({ 
  imageUrl, 
  altText = "Floating Image", 
  autoCloseDelay = 4000,
  showImage, 
  onClose 
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const [gifKey, setGifKey] = useState(0);
  // const [progress, setProgress] = useState(0);
  // const gifSrc = ;
  useEffect(() => {
    console.log('showImage',showImage);
  
    if (showImage) {
      setIsVisible(true);
      // setProgress(0);
       setGifKey(prev => prev + 1);
      // 设置自动关闭定时器
      const closeTimer = setTimeout(() => {
        setIsVisible(false);
        if (onClose) onClose();
      }, autoCloseDelay);

      // 设置进度更新定时器
      const interval = 100;
      const totalIntervals = autoCloseDelay / interval;
      let currentInterval = 0;

      const progressTimer = setInterval(() => {
        currentInterval++;
        // setProgress((currentInterval / totalIntervals) * 100);
        
        if (currentInterval >= totalIntervals) {
          clearInterval(progressTimer);
        }
      }, interval);

      // 清理定时器
      return () => {
        clearTimeout(closeTimer);
        clearInterval(progressTimer);
      };
    } else {
      setIsVisible(false);
    }
  }, [showImage, autoCloseDelay, onClose]);

  if (!isVisible) {
    return null;
  }

  return (
    <div>
      <style>{GlobalStyle}</style>
      <FloatingOverlay>
        <FloatingContent    key={gifKey} >
          <FloatingImage 
         
            src={"https://file.wogoo.com/www/static/584655D4-B26B-4EFD-BD9F-A646350ACED3.gif?v="+ new Date().getTime()} 
            alt={altText}
          />
          {gifKey}
          
        </FloatingContent>
      </FloatingOverlay>
    </div>
  );
};

export default FloatingImageComponent;


// WEBPACK FOOTER //
// ./src/views/activity_210/Fireworks.js